import Grid from '@mui/material/Grid';
import { ValidateDatePicker } from '../../Generic/Forms/ValidateDatePicker';
import { useState } from 'react';
import { useParams } from 'react-router';
import { Arrangement, Person } from '../../GeneratedClient';
import { usePersonLookup } from '../../Model/DirectoryModel';
import { useV1CasesModel } from '../../Model/V1CasesModel';
import { UpdateDialog } from '../../Generic/UpdateDialog';

interface EndArrangementDialogProps {
  v1CaseId: string;
  arrangement: Arrangement;
  onClose: () => void;
}

export function EndArrangementDialog({
  v1CaseId,
  arrangement,
  onClose,
}: EndArrangementDialogProps) {
  const familyIdMaybe = useParams<{ familyId: string }>();
  const familyId = familyIdMaybe.familyId as string;

  const v1CasesModel = useV1CasesModel();
  const personLookup = usePersonLookup();

  const person = personLookup(
    familyId,
    arrangement.partneringFamilyPersonId
  ) as Person;

  const latestChildLocationChange = arrangement.childLocationHistory
    ?.slice()
    .sort((a, b) =>
      a.timestampUtc! < b.timestampUtc!
        ? 1
        : a.timestampUtc! > b.timestampUtc!
          ? -1
          : 0
    )[0];
  const earliestAllowedEndDate =
    latestChildLocationChange?.timestampUtc ?? arrangement.startedAtUtc;

  const [endedAtLocal, setEndedAtLocal] = useState(null as Date | null);

  const [dobError, setDobError] = useState(false);

  async function save() {
    // Enforce that this goes to the very end of the day (11:59:59.999 PM) for now.
    // In the future, this should be a date-only value.
    endedAtLocal?.setHours(23, 59, 59, 999);
    await v1CasesModel.endArrangement(
      familyId,
      v1CaseId,
      arrangement.id!,
      endedAtLocal!
    );
  }

  return (
    <UpdateDialog
      title={`Do you want to end this ${arrangement.arrangementType} arrangement for ${person.firstName} ${person.lastName}?`}
      onClose={onClose}
      onSave={save}
      enableSave={() => endedAtLocal !== null && !dobError}
    >
      <Grid container spacing={2}>
        <Grid size={12}>
          <ValidateDatePicker
            label="When was this arrangement ended?"
            value={endedAtLocal}
            onChange={(date) => setEndedAtLocal(date)}
            onErrorChange={setDobError}
            disableFuture
            minDate={earliestAllowedEndDate}
            textFieldProps={{
              fullWidth: true,
              required: true,
              sx: { marginTop: 1 },
            }}
          />
        </Grid>
      </Grid>
    </UpdateDialog>
  );
}
